<form [formGroup]="form" class="flex flex-col gap-4">
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div class="flex flex-col">
      <span class="soft-label top required">Von</span>
      <soft-ds-date-input formControlName="from" softFieldValidation />
    </div>
    <div class="flex flex-col">
      <span class="soft-label top required">Bis</span>
      <soft-ds-date-input formControlName="to" softFieldValidation />
    </div>
  </div>
</form>

<section class="flex justify-end gap-2 mt-4">
  <soft-ds-button variant="outline" (click)="cancel()">Abbrechen</soft-ds-button>
  <soft-ds-button variant="primary" [disabled]="form.invalid" (click)="export()">
    Exportieren
  </soft-ds-button>
</section>
